__webpack_require__.p = "https://dev-revelation.pages.dev/";